
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/fuer-arbeitgebende",
      function () {
        return require("private-next-pages/[lang]/fuer-arbeitgebende.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/fuer-arbeitgebende"])
      });
    }
  